export const LINE_STYLES = ['solid_thin', 'solid_thick', 'dashed', 'three_dots', 'dotted', 'dash_dot_dash'] as const
export type LineStyle = typeof LINE_STYLES[number]
export const DEFAULT_STYLE = 'solid_thin'
